import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getRouteParams } from '@rad/hooks/useRouting';
import { landingRoutes } from '../../common/routes';
import { usePropertyBack } from '../../hooks/useBackLink';
import E404 from '../system/no-layout-404';
import UnclaimedView from './components/property/unclaimed-view';
// A geocoded address the map has no parcel for. Picking an ArcGIS suggestion on Explore lands
// here, so a visitor can look up any address and see what we hold on it — which, for somewhere
// nobody has touched, is the address and where it is.
//
// Nothing is written to reach this page: the address and point travel in the query string, and
// the parcel is registered only if someone presses Contribute. That keeps an anonymous lookup
// from seeding rows for every address a visitor happens to type.
const AddressProperty = (props) => {
    var _a, _b, _c;
    const params = getRouteParams();
    const address = (_a = params.get('address')) !== null && _a !== void 0 ? _a : '';
    const lon = parseFloat((_b = params.get('lon')) !== null && _b !== void 0 ? _b : '');
    const lat = parseFloat((_c = params.get('lat')) !== null && _c !== void 0 ? _c : '');
    const point = [lon, lat];
    const resolveBack = usePropertyBack();
    return !address || !Number.isFinite(lon) || !Number.isFinite(lat)
        ? _jsx(E404, { urlHome: landingRoutes.root.getURL() })
        : _jsx(UnclaimedView, { address: address, point: point, kind: null, back: resolveBack(), target: { 'kind': 'address', address, point } });
};
export default AddressProperty;
